import React from 'react'
import { Link } from "react-router-dom";

import { useAppStore } from './appStore'
//import ChangeViewLink from 'lib/misc/ChangeViewLink'

export default function Header() {
    const viewMode = useAppStore((state) => state.view)

    return (
        <header className="header">
            <a className="logo" href="/">
                <h2>3motic</h2>
                <h3>- w3 and 3D -</h3>
            </a>
            <input className="side-menu" id="side-menu" type="checkbox" />
            <label className="hamb" htmlFor="side-menu">
                <span className="hamb-line"></span>
            </label>
            <nav className="nav">
                <ul className="menu">
                    <li className="subnav">
                        <a className="subnavbtn">Clips <i className="fa fa-caret-down"></i></a>
                        <div className="subnav-content">
                            <Link to='/clips/monsters'>Monsters</Link>
                            <Link to='/clips/fox-and-rabbit'>Fox and Rabbit</Link>
                            <Link to='/clips/blut-und-traenen'>Blut und Tränen</Link>
                        </div>
                    </li>
                    <li className="subnav">
                        <a className="subnavbtn">Interactive <i className="fa fa-caret-down"></i></a>
                        <div className="subnav-content">
                            <Link to='/interactive/cones'>Cones</Link>
                            <Link to='/interactive/monster'>Monster</Link>
                            <Link to='/interactive/fox-and-rabbit'>Fox and Rabbit</Link>
                        </div>
                    </li>
                    <li>
                        <Link to='/imprint'>Imprint</Link>
                    </li>
                </ul>
            </nav>
        </header>
    )
}
